import { Container, Button, Form, Alert, Modal, Table } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper } from "../ContentStyles";
import { FaBarcode, FaTrash } from 'react-icons/fa';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, { SpinnerX, Loading } from '../../services/useBackend_v2';
import { Branding } from '../../services/misc';

export default function GlobalproductsToHandle() {
    const { loading, data, Refresh, resultVisible, initReady, Check, XCall, Update, setPagination, pagination } = useBackend('/api/admin/globalproductsToHandle');
    const [editProductModalshow, setEditProductModalshow] = useState(false);
    const [editData, setEditData] = useState(null);

    // https://se.product-search.net/

    const navigate = useNavigate();

    const editProductHandler = (event, rowData) => {
        event.preventDefault();
        setEditData(rowData.original);
        setEditProductModalshow(true);        
    }

    async function closeAndRefresh() {
        setEditProductModalshow(false);
        setEditData(null);
        Refresh();
    }

    const columns = useMemo(() => [
        { size: 40, accessorKey: 'EAN', header: 'EAN', enableColumnActions: false },
        { size: 40, accessorKey: 'Name', header: 'Name' },
        { size: 40, accessorKey: 'Datum', header: 'Datum' },
        { size: 40, accessorKey: 'Brand', header: 'Brand' },
        { size: 40, accessorKey: 'Volume_Size', header: 'Volume_Size' },                   
    ]);

    const state = {  };    
    const initialState = { 
        density: 'compact',
        columnVisibility: { Butik: false, Kund:true, 'SerialNumber':true },        
        pagination :{ pageSize: 50 }
    };    

    if (initReady) {
        return (
            <ContentWrapper> 
                <ModalProductEdit show={editProductModalshow} onHide={closeAndRefresh} editData={editData} updateFn={Update}></ModalProductEdit>
                <Container>
                    <Sida>
                        <MaterialReactTable columns={columns} data={data.missingproducts} state={state} initialState={initialState} 
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, labelRowsPerPage: "Rader" }}
                            renderTopToolbarCustomActions={() => (<Rubrik>Varor</Rubrik>)}

                            muiTablePaperProps={{ elevation: 0, sx: { borderRadius: '0', border: '0px dashed #e0e0e0' } }}
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => { editProductHandler(event, row); }, sx: { cursor: 'pointer' },
                            })}
                        />
                        <div className="product-actions">
                        </div>
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);
    }
}

export function ModalProductEdit(props) {
    const defaultValues              = { Guid:"00000000-0000-0000-0000-000000000000", Name: '', Description:"" };

    const [editData, setEditData] = useState(defaultValues);

    async function closeForm() {
        setEditData(defaultValues);
        props.onHide();        
    }
    
    async function showForm() {
        setEditData(props.editData);
    }

    var typingTimeout = null;

    async function handleSave() {
        const ProductForm = document.getElementById('ProductForm');
        const formData = new FormData(ProductForm);
        const formDataObj = Object.fromEntries(formData.entries());


        props.updateFn(formDataObj, "PATCH", 3000, "/api/admin/globalproductsToHandle/" + editData.Guid);
    }

    function handleChange(event) {
        if (props.editProductGuid !== "00000000-0000-0000-0000-000000000000") {
            clearTimeout(typingTimeout);
            typingTimeout = setTimeout(handleSave, 475);
        }
    }    
  
    return (
        <Modal show={props.show} onHide={() => closeForm()} onShow={() => showForm()} >
            
            <Modal.Header closeButton>
                <Modal.Title>{editData.Name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="ProductForm">

                    <Form.Group className="mb-3" >
                        <Form.Label>Namn</Form.Label>
                        <Form.Control type="text" name="Name" placeholder="Namn" defaultValue={editData.Name} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Produktbeskrivning</Form.Label>
                        <Form.Control type="text" name="Description" placeholder="Description" defaultValue={editData.Description} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Varumärke</Form.Label>
                        <Form.Control type="text" name="Brand" placeholder="Brand" defaultValue={editData.Brand} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Tillverkare</Form.Label>
                        <Form.Control type="text" name="Vendor" placeholder="Vendor" defaultValue={editData.Vendor} onChange={handleChange} />
                    </Form.Group>   

                    <Form.Group className="mb-3" >
                        <Form.Label>Volume_Size</Form.Label>
                        <Form.Control type="text" name="Volume_Size" placeholder="Volume_Size" defaultValue={editData.Volume_Size} onChange={handleChange} />
                    </Form.Group>                                                

                    <Form.Group className="mb-3" >
                        <Form.Label>EAN</Form.Label>
                        <Form.Control type="text" name="EAN" placeholder="EAN" defaultValue={editData.EAN}  />
                    </Form.Group>

                    {/* <Form.Group className="mb-3" hidden={!loading}>
                        <SpinnerX />
                    </Form.Group>

                    <Form.Group className="mb-3" hidden={!resultVisible}>
                        <Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert>
                    </Form.Group> */}
                </Form>

            </Modal.Body>
            <Modal.Footer>
                {/* <Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={handleSave}>Lägg till varan</Button> */}
            </Modal.Footer>
        </Modal>            
    )
}